<template>
  <!-- 章节作业 -->
  <div class="uni-startPractice">
    <div class="leftBox" id="leftBox">
      <!-- 标题 -->
      <div>
        <div :class="titleScroll">
          <i class="iconfont iconfanhui" @click="$router.go(-1)"></i>
          <span v-for="(item, index) in otherInfoDTO.title" :key="index">
            {{ item }}
            <em v-if="otherInfoDTO.title.length - 1 !== index"></em>
          </span>
        </div>
      </div>

      <div
        class="topicDivButton"
        :class="fontClass"
        v-for="(itemTo, indexTo) in topicLists"
        :key="indexTo"
      >
        <div
          class="topicDiv"
          :id="itemTo.question_style != 6 && `id_${itemTo.sort}`"
        >
          <!-- 1 单选题 -->
          <ChoiceOne
            v-if="itemTo.question_style === 1"
            :datas="itemTo"
            @next="saveAnswer(itemTo)"
          />
          <!-- 2 判断题 -->
          <Judge
            v-if="itemTo.question_style === 2"
            :datas="itemTo"
            @next="saveAnswer(itemTo)"
          />
          <!-- 3 多选题 -->
          <ChoiceMultiple
            v-if="itemTo.question_style === 3"
            :datas="itemTo"
            @next="saveAnswer(itemTo)"
          />
          <!-- 4 填空题 -->
          <FillBlank
            v-if="itemTo.question_style === 4"
            :datas="itemTo"
            @next="saveAnswer(itemTo)"
          />
          <!-- 5简答题 -->
          <Subjective
            v-if="itemTo.question_style === 5"
            :datas="itemTo"
            @next="saveAnswer(itemTo)"
          />
          <!-- 6 一题多问 -->
          <div v-if="itemTo.question_style === 6">
            <div
              class="questionAskTitle"
              id="questionAskTitle"
              v-html="itemTo.content"
            ></div>
            <!-- 音频 -->
            <div class="audioDiv" v-if="itemTo.audio_url">
              <audio
                class="sourceAudio"
                controls="controls"
                v-for="(itemAudio, indexAudio) in itemTo.audio_url.split(',')"
                :key="indexAudio"
              >
                <source :src="itemAudio" type="audio/ogg" />
                Your browser does not support the audio element.
              </audio>
            </div>
            <!-- 小题 -->
            <div
              v-for="(item, index) in itemTo.child"
              :key="index"
              :id="`id_${item.sort}`"
            >
              <!--      1 单选题-->
              <ChoiceOne
                v-if="item.question_style === 1"
                :datas="item"
                @next="saveAnswer(item)"
              />
              <!--     4 填空题-->
              <FillBlank
                v-if="item.question_style === 4"
                :datas="item"
                @next="saveAnswer(item)"
              />
              <!--      2判断题-->
              <Judge
                v-if="item.question_style === 2"
                :datas="item"
                @next="saveAnswer(item)"
              />
              <!--      3多选题-->
              <ChoiceMultiple
                v-if="item.question_style === 3"
                :datas="item"
                @next="saveAnswer(item)"
              />
              <!-- 5简答题 -->
              <Subjective
                v-if="item.question_style === 5"
                :datas="item"
                @next="saveAnswer(item)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <!-- 工具栏 -->
    <div class="mat20" style="min-height: inherit">
      <AnswerSheet
        :datas="topicCard"
        :total="total"
        @change="jumpTo"
        @submit="submit"
      />
    </div>

    <!-- 提示框 -->
    <ComponentDialog1
      :icon="scoreDialog.icon"
      :title="scoreDialog.title"
      :score="scoreDialog.score"
      :visible.sync="isScoreVisible"
      iconPosition="left-top"
      :showCancelBtn="scoreDialog.showCancelBtn"
      cancelText="重做"
      confirmText="查看解析"
      @cancel="clearCourse"
      @confirm="scoreConfirm"
    />
  </div>
</template>

<script>
import AnswerSheet from "@/components/answerSheet";
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import { getPractice, getRSTopic, saveAnswer, postAnswer, getCollectErr } from "@/api/basic";
import { QuestionTest } from "@/api/realTest";
import { mapState } from "vuex";
export default {
  name: "uni-startPractice",
  computed: {
    ...mapState("common", {
      fontClass: (state) => state.fontClass,
    }),
  },
  components: {
    AnswerSheet, //工具栏
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答题
  },
  data() {
    return {
      make_id:this.$route.query.make_id,
      course_id: this.$route.query.course_id,
      section_id: this.$route.query.section_id,
      question_title: this.$route.query.question_title,
      question_style: this.$route.query.question_style,
      test_id: this.$route.query.test_id,
      titleScroll: "title",
      otherInfoDTO: "",
      topicLists: [],
      topicCard: [],
      total: 0,
      // 分数提示框
      isScoreVisible: false,
      scoreDialog: {
        title: "",
        score: 0,
        icon: "",
        showCancelBtn: true,
      },
    };
  },
  mounted() {
    if (this.question_title) {
      this.getRandomWorks(); //智能练习随机练习
    }else {
      this.getWorks();
    }

    document
      .getElementById("leftBox")
      .addEventListener("scroll", this.ScrollTitle, true);
  },
  destroyed() {},
  methods: {
    // 获取题目列表
    async getWorks() {
      const params = {
        course_id: this.course_id,
        section_id: this.section_id,
        make_id:this.make_id
      };
      const res = await getPractice(params);
      if (res.code == 200) {
        const { info, question, questionTitleList, sum } = res.result;
        this.otherInfoDTO = info;
        this.otherInfoDTO.title = info.title ? info.title.split("|") : [];
        this.topicLists = question;
        this.topicCard = questionTitleList;
        this.total = sum;
      }
    },


    // 获取随机练习题目列表
    async getRandomWorks() {
      const params = {
        course_id: this.course_id,
        question_title: this.question_title,
      };
      const res = await getRSTopic(params);
      if (res.code == 200) {
        const { info, question, questionTitleList } = res.result;
        this.otherInfoDTO = info;
        this.otherInfoDTO.title = info.title ? info.title.split("|") : [];
        this.topicLists = question;
        this.topicCard = questionTitleList;
      }
    },
    // 标题固定
    ScrollTitle(e) {
      if (e.target.scrollTop > 200) {
        this.titleScroll = "titlePosition";
      } else if (e.target.scrollTop <= 100) {
        this.titleScroll = "title";
      }
    },
    /**
     * 点击答题卡到当前题
     */
    jumpTo(sort) {
      let scrollDom = document.getElementById("leftBox");
      let dom = document.querySelector("#id_" + sort);
      if (!dom) {
        return;
      }
      let top = dom.offsetTop - 200;
      scrollDom.scrollTo({
        top: top,
        behavior: "smooth",
      });
    },
    // 保存答案
    saveAnswer(item) {
      // let option = JSON.stringify(item.choice_correct_item);
      // let option = item.choice_correct_item;
      // const params = {
      //   id: item.id,
      //   make_id: item.make_id,
      //   option: option,
      // };
      const params = {
        id: item.id,
        make_id: item.make_id,
        option: item.choice_correct_item || "",
      };
      // if(item.choice_correct_item != '' && item.choice_correct_item != 'null' && item.choice_correct_item != null){
      //   params.option = item.choice_correct_item
      // }
      if(item.choice_correct_thumb != '' && item.choice_correct_thumb != 'null' && item.choice_correct_thumb != null){
        params.choice_correct_thumb = item.choice_correct_thumb
      }
      saveAnswer(params);
      this.changeStatus(item);

      // 单选题、判断题滚动到下一题
      if (item.question_style == 1 || item.question_style == 2) {
        this.jumpTo(item.sort + 1);
      }
    },
    // 改变当前答题卡状态
    changeStatus(item) {
      let isNoEmpty = false;
      if (item.choice_correct_item) {
        isNoEmpty = true;
      }
      if (item.question_style == 4) {
        isNoEmpty = JSON.parse(item.choice_correct_item).some(
          (val) => val.value != ""
        );
      }
      if (item.question_style == 5 && item.choice_correct_thumb) {
        isNoEmpty = true
      }
      this.topicCard.forEach((item2) => {
        item2.list.forEach((val) => {
          if (val.sort == item.sort) {
            val.is_make = isNoEmpty ? 1 : 0;
          }
        });
      });
    },
    // 提交
    async submit() {
      const res = await postAnswer({ make_id: this.otherInfoDTO.id });
      if (res.code == 200) {
        const { info } = res.result;
        this.scoreDialog = {
          title: "本次练习得分！",
          score: info.score,
          icon: "success",
          showCancelBtn: true,
        };
        this.isScoreVisible = true;
      }
    },
    clearCourse() {
      if (this.question_title) {
        this.getRandomWorks(); //智能练习随机练习
      } else {
        this.getWorks();
      }
      this.isScoreVisible = false;
    },
    scoreConfirm() {
      this.$router.replace({
        name: "practiceAnalysis",
        query: {
          make_id: this.otherInfoDTO.id,
          course_id: this.course_id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
</style>
<style lang="scss" scoped>
.topicDivButton {
  background: #fff;
  margin-bottom: 20px;
}
.topicDiv {
  padding-bottom: 30px;
}
.uni-startPractice {
  display: flex;
  min-height: $contentH;
  .iconfanhui {
    color: #999999;
    font-size: 38px;
    position: absolute;
    left: 20px;
    &:hover {
      color: #666666;
    }
  }
  .spanColor {
    color: #666666;
    font-size: 14px;
  }
  .leftBox {
    //background-color: #ffffff;
    height: $contentH;
    flex: 1;
    //padding: 20px 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 20px 20px 0 20px;
    position: relative;
    &::-webkit-scrollbar {
      @include uni-hidden;
    }
    .titlePosition {
      width: calc(100% - 624px);
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      background: #fff;
      height: 80px;
      position: fixed;
      top: $headH;
      z-index: 10;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease;
      span {
        font-size: 20px;
        color: #333;
        font-weight: 400;
        display: flex;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
        em {
          margin: 0 14px;
          display: flex;
          height: 26px;
          width: 1px;
          background: $gray;
        }
      }
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      height: 80px;
      position: relative;
      transition: all 0.3s ease;
      span {
        font-size: 20px;
        color: #333;
        font-weight: 400;
        display: flex;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
        em {
          margin: 0 14px;
          display: flex;
          height: 26px;
          width: 1px;
          background: $gray;
        }
      }
    }

    .total-text {
      display: flex;
      color: $grayLight;
      margin-top: 20px;
      padding: 10px 0;
      border-bottom: 1px solid $grayLight2;
      flex-wrap: wrap;
      .totalTextSpan {
        margin-bottom: 5px;
      }
    }

    .clear {
      margin: 65px 60px 0 60px;
      height: 1px;
      border: 1px dashed #e8e8e8;
    }
    .speed {
      padding-bottom: 52px;
      border-bottom: 1px dashed #e8e8e8;
      .text {
        color: #9a9a9a;
        font-size: 14px;
        margin: 30px 0 20px 0;
      }
      .strip {
        display: flex;
        align-items: center;
        .box {
          flex: 1;
        }
        .textBox {
          margin-left: 32px;
          span {
            font-size: 14px;
            color: #9a9a9a;
            &:first-child {
              color: #f38829;
            }
          }
          em {
            font-style: normal;
            margin: 0 10px;
            color: #9a9a9a;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
.questionAskTitle {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  text-indent: 2em;
  line-height: 26px;
  color: #333;
  word-break: break-word;
  white-space:pre-line
}
.audioDiv {
  display: inline-block;
}
.audioDiv .sourceAudio {
  width: 300px;
  margin: 20px;
}
</style>
